import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "banner",
  ref: "bannerRef"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_About = _resolveComponent("About")!
  const _component_Login = _resolveComponent("Login")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.tabsSelected === 2 ? _ctx.tvicBg : _ctx.tabsSelected === 1 ? _ctx.bvicBg : _ctx.vicBg,
        class: "banner-bg",
        alt: "Banner"
      }, null, 8, _hoisted_2),
      _createVNode(_component_SvgIcon, {
        "icon-name": _ctx.vicLogoName,
        class: "logo-bg"
      }, null, 8, ["icon-name"])
    ], 512),
    _createVNode(_component_Tabs, {
      headers: _ctx.headers,
      selected: _ctx.tabsSelected,
      "onUpdate:selected": _ctx.onTabUpdated
    }, {
      suffix: _withCtx(() => [
        _createElementVNode("div", {
          class: "btn btn-sm home-login-btn",
          textContent: _toDisplayString(_ctx.isLogin ? _ctx.$t('my-account') : _ctx.$t('login')),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLoginClick && _ctx.onLoginClick(...args)))
        }, null, 8, _hoisted_3)
      ]),
      _: 1
    }, 8, ["headers", "selected", "onUpdate:selected"]),
    _createVNode(_component_About, { type: _ctx.tabsSelected }, null, 8, ["type"]),
    (!_ctx.isLogin)
      ? (_openBlock(), _createBlock(_component_Login, {
          key: 0,
          ref: "loginRef",
          type: _ctx.tabsSelected
        }, null, 8, ["type"]))
      : _createCommentVNode("", true)
  ], 64))
}